module.exports = __webpack_public_path__ + "media/ת.4a3d72ba.mp3";